import { render, staticRenderFns } from "./issueTrack.vue?vue&type=template&id=05050b7d&scoped=true&"
import script from "./issueTrack.vue?vue&type=script&lang=js&"
export * from "./issueTrack.vue?vue&type=script&lang=js&"
import style0 from "./issueTrack.vue?vue&type=style&index=0&id=05050b7d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05050b7d",
  null
  
)

export default component.exports